import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Field } from "../../../../components/NewDesign/Forms/Field";
import { Input, InputNumber } from "../../../../components/NewDesign/Forms/Input";
import Button from "../../../../components/NewDesign/Button/Button";
import { CloseCircleIcon, PlusCircularOutlined, RubbishOutlined } from "../../../../components/OldDesign/Icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useStore } from "../../../../store/useStore";
import { useTranslation } from "react-i18next";

const AddJobPosition = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const addJobPosition = useStore((state) => state.addJobPosition);
  const emptyJobPos = { name: "", seat_count: 1 };
  const { state } = useLocation();
  const {
    handleSubmit,
    register,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      job_positions: [emptyJobPos],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "job_positions",
  });

  const handleSubmitJobPositions = async (formData) => {
    await addJobPosition(formData, () => navigate("/cna/ideals"), state.options);
  };

  return (
    <div className="relative flex flex-col items-center gap-4 bg-secondary_recruiter-200 px-16 py-9">
      <button className="absolute right-4 top-4" onClick={() => navigate(-1)}>
        <CloseCircleIcon className="h-6 w-6 text-primary-900" />
      </button>
      <p className="font-semibold leading-tight text-primary-900">{t("modal.add_position.add_your_profile_name")}</p>
      <ul className="flex flex-col items-center gap-2">
        {fields.map((item, index) => {
          return (
            <li key={item.id} className="relative flex items-center gap-2">
              <Field
                label={index === 0 && t("placeholder.profile_name")}
                error={errors.job_positions && errors.job_positions[index]?.name}
                className={"mx-auto max-lg:w-[200px] lg:min-w-[450px]"}
              >
                <Input
                  {...register(`job_positions.${index}.name`, {
                    required: true,
                    maxLength: { value: 100, message: t("message.max_char_count", { char_count: 100 }) },
                    minLength: { value: 3, message: t("message.min_char_count", { char_count: 3 }) },
                  })}
                  placeholder={t("placeholder.profile_name")}
                />
              </Field>
              {index >= 1 && (
                <Button
                  onClick={() => remove(index)}
                  className="absolute -right-12 border-none bg-transparent p-2"
                  icon={<RubbishOutlined className="h-6 w-6 text-secondary_recruiter-600" />}
                />
              )}
            </li>
          );
        })}
        <button onClick={() => append(emptyJobPos)}>
          <PlusCircularOutlined className={"h-6 w-6 text-secondary_recruiter-600"} />
        </button>
      </ul>
      <Button
        loading={isSubmitting}
        className="border-none bg-neutral-100 text-secondary_recruiter-900"
        onClick={handleSubmit((formData, e) => handleSubmitJobPositions(formData))}
      >
        {t("button.submit")}
      </Button>
    </div>
  );
};

export default AddJobPosition;
